// Appropriated from https://codesandbox.io/s/62p6r3kqxz
import React, { Component } from "react"
// eslint-disable-line no-unused-vars
import SvgPlus from "../_svgs/mini/Plus"

import "./_accordion.scss"

class Accordion extends Component {
  static defaultProps = {
    transitionDuration: 200,
    transitionTimingFunction: "ease",
    openClassName: "is-open",
    changeOnClick: true,
  }

  constructor(props) {
    super(props)

    this.state = {
      index: typeof props.selectedIndex !== "undefined" ? props.selectedIndex : -1,
    }
    this.nodes = []
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  toggle(index, click) {
    clearTimeout(this.timeout)

    if (click) {
      if (this.props.onChange) this.props.onChange(index, this.state.index !== index, this.state.index !== index ? index : -1)
      if (!this.props.changeOnClick) return
    }

    //CLOSE FORMER ITEM
    if (this.state.index > -1) {
      const content = this.nodes[this.state.index].ref.children[1]
      content.style.display = "block"
      content.style.height = `${content.offsetHeight}px` // Set fixed height before collapse of current open item

      setTimeout(() => {
        content.style.height = "0px" // Set fixed height before collapse of current open item
        setTimeout(() => {
          content.style.display = "none"
        }, this.props.transitionDuration)
      }, 20)
    }

    //CLOSE FORMER
    if (this.state.index === index) {
      this.setState({ index: -1 })
    } else {
      setTimeout(() => {
        this.setState({ index })

        const content = this.nodes[this.state.index].ref.children[1]

        content.style.display = "block"
        content.style.height = "0" // Set fixed height before collapse of current open item

        this.timeout = setTimeout(() => {
          content.style.height = `${this.getHeight(index)}px`
          this.timeout = setTimeout(() => {
            content.style.height = "auto" // Set auto height after expand
          }, this.props.transitionDuration)
        }, 20)
      }, 20)
    }
  }

  getHeight(index) {
    if (index === this.state.index) {
      return this.nodes.length > index ? this.nodes[index].ref.children[1].children[0].offsetHeight : "auto"
    }
    return 0
  }

  render() {
    const nodes = React.Children.map(this.props.children, (child, index) => {
      if (child !== null)
        return (
          <div
            key={index}
            ref={(div) => {
              this.nodes[index] = { ref: div }
            }}
            className={`${this.props.className}__item ${this.state.index === index ? this.props.openClassName : ""}`}
          >
            <button className={`${this.props.className}__item__trigger`} onClick={() => this.toggle(index, true)}>
              <h5>{child.props["data-header"]}</h5>
              <SvgPlus />
            </button>
            <div className={`${this.props.className}__item__content`} style={{ height: this.getHeight(index) }}>
              {child}
            </div>
          </div>
        )
    })
    return <div className={this.props.className}>{nodes}</div>
  }
}

export default Accordion
